<script>
  import { navigate } from 'svelte-routing';
  import { _ } from 'svelte-i18n';

  import { api } from "./../libs/api.js";

  let loading = false;
  let bad_credentials = false;
  let show_tooltip = false;

  async function handle_login(event) {
    loading = true;
    let form = event.target.parentElement;
    let email = form['email'].value;
    let password = form['password'].value;

    try {
      await api.login(email, password);
      navigate("/start");
    }
    catch(e) {
      bad_credentials = true;
    } finally {
      loading = false;
    }
  }
</script>

<div>
  <div class="hero min-h-screen bg-base-100">

    <div class="w-full max-w-sm p-4">
      <img class="mx-auto mb-4" src="/assets/User.svg" />

      <form class="flex flex-col relative -top-4">
        <input name="email" type="text" placeholder="E-mail" class="bg-accent text-white text-lg w-full px-4 py-2 mt-6 placeholder:text-white placeholder:text-center" />
        <input name="password" type="password" placeholder="Password" class="bg-accent text-white text-lg w-full px-4 py-2 mt-6 placeholder:text-white placeholder:text-center" />

        <button class:loading class="btn btn-accent btn-outline btn-lg uppercase mt-12 w-40 mx-auto" on:click|preventDefault={handle_login}> {$_('base.login')} </button>

        <div class="w-full mt-12 text-center tooltip tooltip-top" class:tooltip-open="{show_tooltip}" data-tip="{$_('base.long_how_to_register')}">
          <label class="w-full block">
            <a class="link link-accent hover:color-accent font-bold block cursor-help">{$_('base.how_to_register')}</a>
            <input type="checkbox" bind:checked="{show_tooltip}" class="checkbox hidden" />
          </label>
        </div>

        {#if bad_credentials}
          <div class="-bottom-24 left-4 right-4 absolute">
            <div class="alert alert-error shadow-lg">
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" class="stroke-current flex-shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                <span> {$_('base.bad_credentials')} </span>
              </div>
            </div>
          </div>
        {/if}
      </form>

    </div>

  </div>
</div>
